import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../HeroSection';
import ProductGrid from '../ProductGrid';
import StickyTextSection from '../Stickytextsection';
import HorizontalGallery from '../Horizontalgallery';
import InstagramSection from '../Instagramsection';
import Footer from '../Footer';

const Home = () => {
  return (
    <div style={{ backgroundColor: '#0D0D0D' }}>
      <Helmet>
        <title>RTK | Prints & Apparel</title>
        <meta name="description" content="Shop RTK — limited edition art prints and apparel." />
      </Helmet>
      <HeroSection />
      <ProductGrid />
      <StickyTextSection />
      <HorizontalGallery />
      <InstagramSection />
      <Footer />
    </div>
  );
};

export default Home;